module.exports = __webpack_public_path__ + "static/media/post_3.ea084aa2.jpeg";